import {
  InjectionToken,
  type Provider,
  type Signal,
} from '@angular/core';

/** Named breakpoints from {@link BreakpointService} (`@marineform/fe-util`). */
export type SscFieldHorizontalFrom = 'tablet' | 'desktop';

/** Horizontal layout from tablet up (`48rem`, matches `BreakpointService.isTablet`). */
export const SSC_FIELD_HORIZONTAL_FROM_TABLET: SscFieldHorizontalFrom = 'tablet';

/** Horizontal layout from desktop up (`64rem`, matches `BreakpointService.isDesktop`). */
export const SSC_FIELD_HORIZONTAL_FROM_DESKTOP: SscFieldHorizontalFrom = 'desktop';

/**
 * Optional breakpoint at which SSC field primitives switch from stacked (default)
 * to horizontal. Omit to keep fields stacked at all sizes.
 */
export const SSC_FIELD_HORIZONTAL_FROM = new InjectionToken<
  Signal<SscFieldHorizontalFrom | undefined>
>('SSC_FIELD_HORIZONTAL_FROM');

export function provideSscFieldHorizontalFrom(
  factory: () => Signal<SscFieldHorizontalFrom | undefined>,
): Provider {
  return { provide: SSC_FIELD_HORIZONTAL_FROM, useFactory: factory };
}
